export default {
  setLoading(state, value) {
    state.loading = value;
  },
  setProfile(state, value) {
    state.profile = value;
  },
  setError(state, value) {
    state.error = value;
  },
};
